import Image from "next/image"
import StarRating from "../../components/StarRating"

export default function PetTransportReviews() {
  return (
    <section className="relative w-full page-padding">
      <h3 className="mb-11 font-montserrat font-semibold text-3xl text-center">
        100,000+ successful pet transports tell our story
      </h3>
      <article className="w-full p-8 space-y-6 bg-white drop-shadow-card rounded-2xl">
        <section className="flex justify-between flex-col-reverse sm:flex-row ">
          <div className="flex space-x-3 items-center">
            <Image
              className="rounded-full"
              src="/icons/transport-prof.webp"
              alt="motorcycle on the road"
              width={60}
              height={60}
            />
            <div className="">
              <p className="m-0 font-bold">Melissa Chenevert</p>
              <StarRating value={5} />
            </div>
          </div>
          <div className="flex items-center">
            <Image
              className="mb-4 sm:mb-0"
              src="/icons/trust-pilot.svg"
              alt="trustpilot logo"
              width={150}
              height={50}
            />
          </div>
        </section>
        <p>
          I had my puppy ship from Illinois to Georgia. The driver was very
          courteous he kept me informed with calls text and pictures of my puppy
          along the way. I highly recommend them.
        </p>
        <div className="flex space-x-2">
          <Image
            className=""
            src="/icons/pet-icon-1.webp"
            alt="pet icon"
            width={70}
            height={70}
          />
          <Image
            className=""
            src="/icons/pet-icon-2.webp"
            alt="pet icon"
            width={70}
            height={70}
          />
        </div>
      </article>
    </section>
  )
}
